<template>
    <div>
        <v-data-table
            :items="items"
            :headers="headers"
            :loading="isLoading"
            :server-items-length="itemsLength"
            :footer-props="{ 'items-per-page-options': [itemsPerPage] }"
            item-key="id"
            :page.sync="pageSync"
            disable-pagination
            disable-sort
            disable-filtering
            :expanded="items"
            no-data-text="Нет данных для отображения"
        >
            <template v-for="(header, index) in headers" v-slot:[`header.${header.value}`]>
                <div :key="index" v-html="header.text"></div>
            </template>
            <template v-slot:item.serial_number="{ item }">
                <div>
                    <div v-if="isContract">
                        <div>{{ item.contract_number }}</div>
                        <div>{{ item.contractor_name }}</div>
                        <div v-for="object of item.objects" :key="object['object_contract_number']">
                            <div>{{ object.object_contract_number }}</div>
                            <div>{{ object.object_name }}</div>
                        </div>
                    </div>
                    <div v-else>
                        <div>{{ item.account_number }}</div>
                        <div v-if="item.person_name">{{ item.person_name }}</div>
                    </div>
                    <div class="pt-4">
                        <v-btn @click.stop="openCreateActDialog(item)" small height="64" width="177" rounded color="gray">
                            <div class=" d-flex">
                                <v-icon color="white">add</v-icon>
                                <div class="white--text text-left">
                                    акт<br />
                                    на отключение/<br />подключение
                                </div>
                            </div>
                        </v-btn>
                    </div>
                </div>
            </template>
            <template v-slot:item.address="{ item }">
                <div>
                    <div v-for="object of item.objects" :key="object['object_contract_number']">
                        {{ object.address_full_name }}
                    </div>
                    <div>{{ item.address_full_name }}</div>
                </div>
            </template>
            <template v-slot:item.services="{ item }">
                <div>
                    <div v-for="(service, idx) of item['services']" :key="idx">
                        <div>{{ service['serv'] }}</div>
                        <div :class="service['status'] ? 'success--text' : 'warning--text'">{{ service['status'] ? 'Подключено' : 'Отключено' }}</div>
                        <div>{{ service['status_date'] }}</div>
                        <br v-if="idx !== item['services'].length - 1" />
                    </div>
                </div>
            </template>
            <template v-slot:item.debts_info="{ item }">
                <div>
                    <div v-for="debtInfo of item['debts_info']" :key="debtInfo.record_id">
                        <div>
                            {{ debtInfo['sum_debt'] }}
                        </div>
                        <div>
                            {{ debtInfo['suppl_service_group_name'] }}
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <InnerActsTable :item="item" :isContract="isContract" @openEmailDialog="openEmailDialog" @openedAct="openedAct" />
                </td>
            </template>
        </v-data-table>
        <EmailDialog v-model="emailDialog" :item="act" />
        <CreateAct v-model="createActDialog" :is-contract="isContract" :info-create-model.sync="infoCreate" ref="createAct" />
        <ObjectsContractActsTable @chooseObject="chooseObject" v-if="isContract" v-model="objectContractDilog" :item="item" />
    </div>
</template>

<script>
import InnerActsTable from '@/components/acts/InnerActsTable.vue';
import EmailDialog from '@/components/acts/EmailDialog.vue';
import CreateAct from '@/components/acts/CreateAct.vue';
import translate from '@/utils/translate.util';
import ObjectsContractActsTable from '@/components/acts/ObjectsContractActsTable.vue';
import { mask } from '@/main';

export default {
    name: 'ActsTable.vue',
    components: { ObjectsContractActsTable, CreateAct, EmailDialog, InnerActsTable },
    data: function() {
        return {
            emailDialog: false,
            act: null,
            createActDialog: false,
            infoCreate: {},
            objectContractDilog: false,
            openDialogCount: 0,
            item: {}
        };
    },
    inject: ['getInfoCreate'],
    props: {
        items: {
            required: true
        },
        headers: {
            required: true
        },
        itemsLength: {
            required: true
        },
        itemsPerPage: {
            required: true
        },
        isLoading: {
            required: true
        },
        page: {
            required: true
        },
        selected: {
            required: true
        },
        isContract: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        pageSync: {
            get() {
                return this.page;
            },
            set(val) {
                this.$emit('update:page', val);
            }
        }
    },
    methods: {
        openEmailDialog(val) {
            this.emailDialog = val;
        },
        openedAct(act) {
            this.act = act;
        },
        async openCreateActDialog(item) {
            this.item = item;
            if (!this.isContract) {
                const infoCreate = await this.getInfoCreate(item.account_rid);
                if (!infoCreate.successfull) return;
                this.infoCreate = translate(infoCreate.data[0], 'full', this.$i18n.locale);
                this.infoCreate['account_rid'] = item.account_rid;
                this.createActDialog = true;
            } else {
                const infoCreate = await this.getInfoCreate(item.object_suppl_rid);
                if (!infoCreate.successfull) return;
                this.infoCreate = translate(infoCreate.data[0], 'full', this.$i18n.locale);
                this.infoCreate['obj_suppl_rid'] = item.object_suppl_rid;
                this.infoCreate['serv'] = this.infoCreate['serv'] ?? [];
                this.infoCreate['other_serv'] = this.infoCreate['other_serv'] ?? [];
                this.infoCreate['phone'] = this.openDialogCount == 0 ? mask.unmasked(this.infoCreate['phone']) : this.infoCreate['phone'];
                this.createActDialog = true;
            }
            this.openDialogCount++;
        },
        async chooseObject(objectId) {
            this.objectContractDilog = false;
            const infoCreate = await this.getInfoCreate(objectId);
            if (!infoCreate.successfull) return;
            this.infoCreate = translate(infoCreate.data[0], 'full', this.$i18n.locale);
            this.infoCreate['obj_suppl_rid'] = objectId;
            this.createActDialog = true;
        },
        actSign(id) {
            this.createActDialog = true;
            this.$refs.createAct.onlySign(id);
        }
    }
};
</script>

<style scoped></style>
